export default "__VITE_ASSET__wKqEXW1L__"